import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { GlobalMessageService, GlobalMessage } from '../../services/global-message.service';

@Component({
  selector: 'global-error',
  templateUrl: './global-error.dialog.html'
})
export class GlobalErrorComponent implements OnInit {
  @ViewChild('globalErrorDialog') globalErrorDialog: TemplateRef<any>;

  globalErrorDialogRef: BsModalRef;
	message: GlobalMessage = new GlobalMessage('', new Date());
	display:string = 'off';

  constructor(globalMessageService: GlobalMessageService, private modalService: BsModalService) {
  	globalMessageService.errorAdded$.subscribe(message => this.onMessage(message));
  }

  ngOnInit() {
  }

  private onMessage(message: GlobalMessage): void {
  	this.message = message;
  	this.globalErrorDialogRef = this.modalService.show(this.globalErrorDialog);
  }
}



// WEBPACK FOOTER //
// ./client/app/global/global-error/global-error.component.ts